<template>
	<div class="aboutCertificates">
		<my-header active="0" />
		<div class="main">
			<div class="container">
				<div class="current ">
					<p>当前位置：首页>服务协议</p>
				</div>
                <div class="warp">
                    <examination-sidebar />
                    <div class="sidebar-right">
                        <h1>服务协议</h1>
                        <p>若要使用xxxx电子服务有限公司(xxxx)网站中的任何内容或信息，请您阅读使用条款。请注意访问和/或使用本网站(如复制任何信息等)，即表示您接受这些使用条款。如果不接受这些使用条款，请离开并停止使用本网站。</p>
                        <p>本网站及其所有下属网站(统称本网站”)，是由xxxx电子服务有限公司发布和维护。使用本网站即表示您同意本法律声明(使用条款”)中所陈述的条款和条件。如果您不同意该使用条款，请不要使用本网站。</p>
                        <p>我们随时可能会更改或修订使用条款的内容。因此您应在每次访问本网站的同时访问这些使用条款网页。如果您在我们更改或修订了使用条款后继续使用本网站，即表示您同意新的使用条款。</p>
                        <p>本网站上的所有内容，包括全部图像、软件、文字和图形、按钮、关键词、标签以及整体外观(简称内容”)，均受国家法律及国际条约版权保护。本网站内包括的标志、公司商标和徽章均属于xxxx电子服务有限公司(xxxx)或其内容提供商的商标和其它权利。在不受前述内容限制的前提下，除在此指明的情况外，您不允许使用本网站内容。违反本条款将侵犯xxxx电子服务有限公司(xxxx)或其内容提供商的知识产权，xxxx电子服务有限公司(xxxx)或其内容提供商可能会诉诸法律来维护这些权利。</p>
                        <p>本网站内容可供阅读和打印，网站上的文件可供分发，前提是仅可用于信息参考和非商业个人目的，且在使用文件时应注明出自xxxx电子服务有限公司(xxxx)。不允许交换、修改、出售或传播本网站的任何内容。新闻发布及其它注明为公共性质的文件，在注明信息来源的情况下可用于公共交流。</p>
                    </div>
                </div>
            </div>
            <my-footer />
        </div>   
    </div>
</template>

<script>
export default {
	name: 'service',
	components: {

	},
	data(){
		return {
		}
	},
	mounted(){
		
	}
}
</script>

<style scoped>
.sidebar-right{
    padding-top: 13px;
    padding-bottom: 135px;
}
.sidebar-right h1{
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
}
.sidebar-right p{
    font-size: 14px;
    line-height: 26px;
    padding: 8px 0;
    text-indent:2em;
}
</style>
